import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import NotFound from '../NotFound/NotFound';
import MyProcedure from './MyProcedure/MyProcedure';
import PurchasingGroup from "./PurchasingGroup/PurchasingGroup";
import Admin from "./Admin/Admin";
import PurchaserDemand from "./demand/PurchaserDemand";
import AnnualReport from "./annualReport/AnnualReport";

function PurchaserRouter(props) {

    return (
        <Switch>
            <Route exact path={RouterPath.BUYER_INIT}>
                <Redirect to={RouterPath.MY_PROCEDURE}/>
            </Route>
            <Route path={RouterPath.MY_PROCEDURE} component={MyProcedure}/>
            <Route exact path={RouterPath.PURCHASER_INIT}>
                <Redirect to={RouterPath.MY_PROCEDURE}/>
            </Route>
            <Route path={RouterPath.PURCHASING_GROUP} component={PurchasingGroup}/>
            <Route path={RouterPath.ANNUAL_REPORT} component={AnnualReport}/>
            <Route path={RouterPath.ADMIN} component={Admin}/>
            <Route path={RouterPath.DEMAND} component={PurchaserDemand}/>

            <Route component={NotFound}/>
        </Switch>
    )
}

export default PurchaserRouter;
